module.exports = __webpack_public_path__ + "img/service3.ad3119ad.png";